import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  root: css`
    && {
      min-height: 1px;
    }
  `,
}
